/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as pxp from './PXPApp'
import { componentApi, loadTranslations } from 'common'


export class FrontlinePortal {
  async LoadData(agu : string) : Promise<any> {
    return await componentApi.call('pxp', 'frontline-portal', 'FrontlinePortal', 'LoadData', {
      agu,
    });
  }
}
export default new FrontlinePortal()
